export const finalPrice = (price = 0.00, discont = 0) => {
    const totalDiscount = discont / 100 * price;
    return price - totalDiscount
}